import {view} from '@sail/ui/deprecated';
import {useCallback, useContext, useEffect, useState} from 'react';
import {captureMessage} from '@sentry/browser';
import {RequestACallForm} from '../components/Forms/RequestACall';
import {ScreenName, SplashScreen, useScreen} from '../Providers/ScreenProvider';
import {ConfigContext} from '../Providers/ConfigProvider';
import {EligibleChannelsEndpointResponseChannelRequestACall} from '../../generated/types';
import {getWaitTime} from '../components/ChannelSelector/getDisplayChannels';
import {useEligibleChannels} from '../components/ChannelSelector';

type Props = {
  topic: string;
};

export const RequestACallScreen = ({topic}: Props) => {
  const {audience, entrypoint: entryPoint} = useContext(ConfigContext);

  const {eligibleChannels} = useEligibleChannels();
  const [channel, setChannel] = useState<
    EligibleChannelsEndpointResponseChannelRequestACall | undefined
  >();

  const {transitionTo} = useScreen();

  useEffect(() => {
    if (!eligibleChannels) {
      return;
    }

    const racChannel = eligibleChannels?.find((c) => {
      return c.type === 'request_a_call';
    }) as EligibleChannelsEndpointResponseChannelRequestACall | undefined;
    if (racChannel) {
      setChannel(racChannel);
    } else {
      // we somehow navigated to the RAC screen even though we're not eligible for RAC
      transitionTo(SplashScreen);
      captureMessage('Navigated to RAC screen without being eligible', {
        extra: {
          audience,
          entryPoint,
          topic,
          eligibleChannels,
        },
      });
    }
  }, [audience, eligibleChannels, entryPoint, topic, transitionTo]);

  const handleSuccess = useCallback(
    ({name, phoneNumber}: {name: string; phoneNumber: string}) => {
      transitionTo({
        name: ScreenName.RequestACallConfirmation,
        props: {
          name,
          phoneNumber,
          waitTime: getWaitTime(channel!, false),
        },
      });
    },
    [transitionTo, channel],
  );

  const handleCancel = useCallback(() => {
    transitionTo(SplashScreen);
  }, [transitionTo]);

  return (
    <view.div
      data-testid="request-a-call-form-screen"
      css={{padding: 'medium'}}
    >
      <RequestACallForm
        topic={topic}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </view.div>
  );
};
